/**
 * Get the auth token from whichever storage it's in.
 * Remember Me ON = localStorage, Remember Me OFF = sessionStorage.
 */
export const getToken = () =>
  localStorage.getItem('token') || sessionStorage.getItem('token');
